import React from 'react';

// splits only on the FIRST '=' — everything after it (even if it contains more '=' signs,
// e.g. base64/JWT-style tokens with padding) stays intact as the value
const splitFirstEquals = (pair) => {
    const idx = pair.indexOf('=');
    if (idx === -1) {
        return [pair, undefined];
    }
    return [pair.substring(0, idx), pair.substring(idx + 1)];
};

const Urlencoder = (url) => {
    var newUrl = url.split('?')
    const decodedParams = atob(newUrl[1])
    // console.log(decodedParams)
    var obj = {}
    if (decodedParams.includes('&')) {
        var arr = decodedParams.split('&')
        for (var i = 0; i < arr.length; i++) {
            var [newkey, value] = splitFirstEquals(arr[i])
            obj[newkey] = value
        }
    } else {
        var [newkey, value] = splitFirstEquals(decodedParams)
        obj[newkey] = value
    }
    // console.log(obj)
    return obj
};

export default Urlencoder;